<template>
  <div class="main-con">
    <div class="loading-animation" v-if="isVideoLoading"><span class="mdi mdi-loading mdi-spin mdi-48px"></span></div>
    <div style="width: 100%; display: flex; padding: 0 32px; margin-bottom: 8px; justify-content: space-between;">
      <div style="display: flex;">
        <div class="tabs is-toggle is-small">
          <ul>
            <li :class="{'is-active': !archiveSwitch}">
              <a id="video-catalog-tab" style="width: 128px;" @click="archiveSwitch=false"><span>一覧</span></a>
            </li>
            <li :class="{'is-active': archiveSwitch}">
              <a id="video-archive-tab" style="width: 128px;" @click="archiveSwitch=true"><span>アーカイブ</span></a>
            </li>
          </ul>
        </div>
        <b-autocomplete
          size="is-small"
          style="width: 250px; height: 27px; margin-left: 32px; margin-right: 8px;"
          v-model="autocompleteWords"
          placeholder="🔍タグ名またはファイル名で検索"
          :open-on-focus="true"
          :data="filteredTagsList"
          field="tag"
          @select="option => searchWords = option.tag">
        </b-autocomplete>
        <button class="button is-primary is-small" id="uploadVideo" @click="changeCreateMedia({
          flg: true,
          type: 'movie'
        })">
          <b-icon icon="upload"></b-icon>
          <span>新しく動画を追加する</span>
        </button>
        <div class="tag is-primary is-small" style="margin-left: 8px; height: 27px; cursor: pointer;" v-if="selectedItem.length!=0" @click="selectStatus={}">全選択解除</div>
        <div class="tag is-primary is-small" style="margin-left: 8px; height: 27px; cursor: pointer;" v-if="selectedItem.length!=0" @click="openMultiModal()">一括編集</div>
      </div>
      <div>
        <b-select
          v-model="filter"
          :value="filterItem[0].value"
          size="is-small"
          placeholder="Select a name">
          <option
            v-for="(item, i) in filterItem"
            :key="i"
            :value="item.value"
            >
            {{ item.name }}
          </option>
        </b-select>
      </div>
      <div>
        <button @click="changeSize('large')" class="button is-small" :class="{'is-primary': size === 'large'}">大</button>
        <button @click="changeSize('small')" class="button is-small" :class="{'is-primary': size === 'small'}">小</button>
      </div>
    </div>
    <div class="pagination-container">
      <b-pagination
        :total="sortArchive.length"
        :current.sync="pages"
        :per-page="12">
      </b-pagination>
    </div>
    <div class="container-video disp-scroll">
      <draggable id="video-list" :list="sortArchive" @end="saveVideoOrder(sortArchive)" :options="{animation: 300, group: { name: 'VIDEO', pull: 'clone', put: false}, handle: '.drag-button'}" >
        <div  class="video-container drag-button"
        :class="{'video-container-large': size === 'large', 'video-container-small': size === 'small'}"
              v-for="(img, index) in sortArchive" :key="index"
              v-if="index >= ((pages - 1) * 12) && index  < (pages * 12)"
              @dragstart="startDrag(img)">
          <div style="height: 200px; width: 100%; overflow: hidden;">
            <video class="video" :src="img.video_data" muted @click="showDetail(img.video_order)"></video>
          </div>
          <input type="checkbox" class="checkbox-select" v-model="selectStatus[img.video_id]">
          <div class="video-info">
            <p style="width: 100%; height: 32px; text-align: left; padding: 4px;">{{ img.name ? img.name : 'no name' }}</p>
            <div class="taglist">
              <template v-if="img.tags">
                <div class="tag is-primary is-small" style="margin-right: 5px; margin-bottom: 5px;" v-for="(t, i) in img.tags.split(',')" :key="i" v-show="t != ''">
                  {{t}}
                  <span class="mdi mdi-close delete-tag-btn" name="delete-tag-btn" style="margin-left:5px;" @click="deleteTags(img,i)"></span>
                </div>
              </template>
              <div class="tag is-primary is-small" style="margin-bottom: 5px;">
                <inputTag :child="img" :index="index" ref="refinput"/>
                <button class="plus-button mdi mdi-plus mdi-24px" @click="$refs.refinput[index].updateTags()"></button>
              </div>
            </div>
            <div v-show="isClickTag && isClickId==img.video_id">
              <button class="tag is-small buttonCandidate"  v-for="(t, i) in searchWordsBox" :key="i"  @click="tagCandidate(img, index, t[0])">
                {{t[0]}}
              </button>
            </div>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'moviePool',
  componentName: 'MoviePool',
  components: {
    draggable,
    inputTag: {
      template: `<input class="edit-taginput" placeholder="タグを設定" v-model="tag" ref="tag" @focus="isClick(true)" @keypress.enter="updateTags(index)"/>`,
      props: ['child', 'index'],
      data () {
        return {
          tag: '',
          tagList:[
            ["採用", "さいよう", "saiyou"],
            ["求人", "きゅうじん", "kyuujinn"],
            ["求人ノベル", "きゅうじんのべる", "kyuujinnnoberu"],
            ["求人ページ", "きゅうじんぺーじ", "kyuujinnpe-ji"],
            ["人物", "じんぶつ", "jinnbutsu"],
            ["背景", "はいけい", "haikei"],
            ["ロボ", "ろぼ", "robo"]
          ],
        }
      },
      mounted(){
        this.$nextTick(() => {
          const $input = this.$refs.tag;
          $input.addEventListener("keyup", this.update);
          $input.addEventListener("compositionend", this.update);
        });
      },
      methods: {
        isClick(flg){
          console.debug('*** Start *** isClick')
          this.$store.dispatch('mediapool/isClickTag',{
            type:'video',
            flg:flg,
            id:this.child.video_id,
            tagList:this.tagList
          })
          console.debug('*** End *** isClick')
        },
        tagBlank(){
          console.debug('*** Start *** tagBlank')
          this.tag=''
          console.debug('*** End *** tagBlank')
        },
        update(e) {
          this.tag = e.target.value;
          this.$store.dispatch('mediapool/searchWordsInitial', {tag:this.tag,tagList:this.tagList})
        },
        getUniqueValues ([...array]){
          return array.filter((value, index, self) => self.indexOf(value) === self.lastIndexOf(value));
        },
        getArraysIntersect (array01, array02) {
          return [...new Set(array01)].filter(value => array02.includes(value));
        },
        updateTags () {
          console.debug('*** Start *** updateTags')
          if (this.tag == '') alert('文字を入力してください。')
          var tagBox = []
          if (this.child.tags) {
            tagBox.push(this.child.tags.split(","))
            if (tagBox[0].indexOf(this.tag) == -1){
              let updateChild = this.child
              if (updateChild.tags) updateChild.tags += this.tag + ','
              else updateChild.tags = this.tag + ','
              this.$store.dispatch('mediapool/updateVideo', updateChild)
            }
          }
          else {
            let updateChild = this.child
            updateChild.tags = this.tag + ','
            this.$store.dispatch('mediapool/updateVideo', updateChild)
          }
          this.tag = ''
          console.debug('*** End *** updateTags')
        }
      }
    }
  },
  computed: {
    ...mapState('mediapool', ['videos', 'isVideoLoading', 'isVideoSaving', 'searchWordsBox', 'isClickTag', 'isClickId', 'isClick']),
    sortArchive () {
      let vids = []
      // 検索
      for (let v of this.videos) {
        if (v.is_archive === this.archiveSwitch && (this.searchWords && ((v.tags && v.tags.indexOf(this.searchWords) >= 0 || v.name.indexOf(this.searchWords) >= 0)) || !this.searchWords)) {
          vids.push(v)
        }
      }
      switch (this.filter) {
        case "old":
          vids.reverse();
          break;
        case "nameAsc":
          vids.sort((a,b) => a.name.localeCompare(b.name, "ja", { numeric: true }));
          break;
        case "nameDesc":
          vids.sort((a,b) => a.name.localeCompare(b.name, "ja", { numeric: true })).reverse();
          break;
        case "scenarioVideo":
          vids = vids.filter(v => v.scenario_video_ref === true)
          break;
        case "storydialogMovie":
          vids = vids.filter(v => v.storydialog_movie_ref === true)
          break;
      }
      return vids
    },
    filteredTagsList() {
      // 入力された文字に一致するタグだけフィルタリング
      return this.searchTagList.filter((option) => {
        if (option.isArchive !== this.archiveSwitch) return false
        return option.tag
          .toString()
          .toLowerCase()
          .indexOf(this.autocompleteWords.toLowerCase()) >= 0
      })
    },
    selectedItem () {
      return this.videos.filter((vd) => {return this.selectStatus[vd.video_id]})
    }
  },
  data () {
    const filterItem = [
      {
        value: "new",
        name: "新着順"
      },
      {
        value: "old",
        name: "投稿順"
      },
      {
        value: "nameAsc",
        name: "名前順（昇順）"
      },
      {
        value: "nameDesc",
        name: "名前順（降順）"
      },
      {
        value: "scenarioVideo",
        name: "ロボ（シナリオ）"
      },
      {
        value: "storydialogMovie",
        name: "ノベル内"
      },
    ]
    return {
      name: '',
      uploadedFile: null,
      searchWords: null,
      archiveSwitch: false,
      tagCandidateList:[],
      pages: 1,
      dragCard: [],
      autocompleteWords: '',
      searchTagList: [],
      selectStatus: {},
      size: "large",
      filterItem: filterItem,
      filter: "new"
    }
  },
  mounted () {
    console.debug('*** Start *** mounted')
    this.$store.dispatch('mediapool/getAllVideos')
    console.debug('*** End *** mounted')
  },
  watch: {
    autocompleteWords () {
      // 直接b-autocompleteのv-modelにするとエラーになるので迂回して格納
      this.searchWords = this.autocompleteWords;
    },
    videos () {
      console.debug('*** Start *** videos')
      // タグ一覧初期化
      this.searchTagList = []

      // タグの一覧作成
      var allTags = []
      for (let video of this.videos) {
        // 各メディアのタグを収集
        if (video.tags) {
          // 空を除いて全て配列化
          var tagInfo = []
          var tags = video.tags.split(',').filter(Boolean)
          for (let tag of tags) {
            tagInfo.push({
              tag: tag,
              isArchive: video.is_archive
            })
          }
          allTags = allTags.concat(tagInfo)
        }
      }
      if (allTags) {
        // 重複を削除してソート
        this.searchTagList = allTags.filter( function (tag1, index, list) {
          return list.findIndex(function(tag2){
            return (tag1.tag === tag2.tag && tag1.isArchive === tag2.isArchive)
          }) === index
        })
        this.searchTagList.sort(function(tag1, tag2){
          if (tag1.tag > tag2.tag) return 1
          return -1
        })
      }
      console.debug('*** End *** videos')
    }
  },
  methods: {
    changeCreateMedia (data) {
      this.$emit('changeCreateMedia', data)
    },
    loadFile (e) {
      if (!this.uploadedFile) return
      let createFile = new FormData()
      createFile.append('name', this.uploadedFile.name)
      createFile.append('video_data', this.uploadedFile)
      this.$store.dispatch('mediapool/saveVideo', createFile)
    },
    showDetail(index) {
      this.$store.dispatch('mediapool/openEditModal', {type: 'video', idx: index, flg: this.archiveSwitch})
    },
    openMultiModal() {
      this.$store.dispatch('mediapool/openMultiEditModal', {type: 'video', data: this.selectedItem, flg: this.archiveSwitch})
    },
    tagCandidate(img, index, t){
      console.debug('*** Start *** tagCandidate')
      console.debug('index: ' + index)
      console.debug('t: ' + t)
      console.debug('this.isClick: ' + this.isClick)
      var tagBox = []
      if (!this.videos[this.isClick].tags) {
        let updateData = img
        updateData.tags = t + ','
        console.debug('updateData: ' + JSON.stringify(updateData))
        this.$store.dispatch('mediapool/updateVideo', updateData)
      } else {
        tagBox.push(this.videos[this.isClick].tags.split(","))
        if (tagBox[0].indexOf(t) == -1){
          let updateData = img
          if (updateData.tags) updateData.tags += t + ','
          else updateData.tags = t + ','
          console.debug('updateData: ' + JSON.stringify(updateData))
          this.$store.dispatch('mediapool/updateVideo', updateData)
          this.$refs.refinput[index].tagBlank()
        }
      }
      console.debug('*** End *** tagCandidate')
    },
    deleteTags(img, i){
      console.debug('*** Start *** deleteTags')
      var tagBox=[]
      var tagText=""
      tagBox.push(img.tags.split(","))
      tagBox[0].splice(i, 1)
      tagText = tagBox[0].join(",")
      let updateData = img
      updateData.tags = tagText
      this.$store.dispatch('mediapool/updateVideo', updateData)
      console.debug('*** End *** deleteTags')
    },
    saveVideoOrder(vids){
      let videos = []
      videos = this.videos
      // ドラッグしたカードをvideosから削除
      const dragCardIdx = videos.indexOf(this.dragCard)
      if(dragCardIdx >= 0) {
        videos.splice(dragCardIdx, 1)
      }
      // 配列からドラッグした場所の1つ前のシナリオを探して後ろにdragCardを挿入
      for (let i in vids) {
        if (vids[i] == this.dragCard && vids[i - 1] == undefined) {
          videos.unshift(this.dragCard)
        } else if (vids[i] == this.dragCard && vids[i - 1] != undefined) {
          const prevVideo = vids[i - 1]
          const insertIdx = videos.indexOf(prevVideo) + 1
          videos.splice(insertIdx, 0, this.dragCard)
        }
      }
      // video_orderを振り直してアップデート
      let obj = []
      for (let i in videos) {
        videos[i].video_order = Number(i) + 1
        obj.push(videos[i])
      }
      this.$store.dispatch('mediapool/updateOrderVideo', obj)
    },
    startDrag (img) {
      this.dragCard = img
    },
    changeSize (size) {
      this.size = size
    }
  }
}
</script>

<style lang="scss" scoped>
.main-con {
  width: 100%;
  height: calc(100% - 120px);
  position: relative;
}
.container-video {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: calc(100% - 120px);
  position: relative;
  margin-bottom: 16px;
}
.loading-animation {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;
  text-align: center;
  vertical-align: middle;
  background: rgba(255, 255, 255, 0.2);
}
.video-container {
  position: relative;
  width:  calc(33.3% - 12px);
  height: auto;
  margin: 8px;
  margin-right: 4px;
  padding: 8px;
  background: #f8f8f8;
  page-break-inside: avoid;
  break-inside: avoid;
  &-small {
    width:  calc(16.6% - 12px);
  }
  &-large {
    width:  calc(33.3% - 12px);
  }
}
.taglist {
  width: 100%;
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
}
.taglist::-webkit-scrollbar {
  width:  5px;
  height: 5px;
  visibility: hidden;
}
.upload-button {
  cursor: pointer;
  border: none;
  background: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.video {
  height: 200px;
  width: 100%;
  object-fit: cover;
  transition: 0.5s;
}
.video:hover {
  transform: scale(1.1);
}
.video-info {
  height: 100px;
  width: 100%;
  background: #f8f8f8;
  padding: 8px;
}
.video-info > p {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: auto; max-width: 100%;
  overflow: hidden;
}
#video-list{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  position: relative;
}
.plus-button {
  background: rgba(255, 255, 255, 0.0);
  cursor: pointer;
  color: white;
  border: none;
  outline : none;
}
.edit-taginput {
  background: rgba(255,255,255, 0.00) !important;
  width: 80px;
  text-align: center;
  color: white;
  border: none;
  font-size: 12px;
  option {
    color: #000;
  }
}
.edit-taginput::placeholder {
  color: white;
  font-size: 12px;
}

.buttonCandidate{
  background-color: white;
  float:left;
  margin-right: 5px;
  margin-bottom: 5px;
  border:solid black 1px;
  cursor: pointer;
  cursor: hand;
}

.buttonCandidate:hover{
  color:white;
  background-color: black;
}
.pagination-container {
  width: 80%;
  margin: auto;
  margin-bottom: 16px;
}

.checkbox-select{
  position: absolute;
  top: 10px;
  right: 10px;
  width: 25px;
  height: 25px;
}

</style>



// WEBPACK FOOTER //
// src/views/DashBoard/MediaPool/MoviePool.vue